<div class="col-8">
	<div id="map" class="map-container"></div>
</div>
